module.exports = __webpack_public_path__ + "static/media/internship_icon.45e7f9b4.svg";